<template>
  <body id="app">
    <div class='wrapper'>
      <Nav/>
      <router-view ></router-view>
      <div class='push'></div>
    </div>
    <footer class="container-fluid bg-secondary footer" >
      <div class="text-white text-center p-3 mb-2">
        <div class="text-center"> 2020 &copy; josiah vranyes</div>
      </div>
    </footer>
  </body>
</template>
<script>
import Nav from './components/Nav.vue'
export default {
  name: 'app',
  components: {
    Nav
  },
  data () {
    return {
    }
  },
  mounted () {
    window.addEventListener('keypress', function (e) {
      if (e.code === 'KeyQ' ) { // && e.altKey) {
        this.$router.push('/admin')
      }
    }.bind(this))
  }
}
</script>
<style>
html, body {
  height: 100%;
  margin: 0;
}
.wrapper {
  min-height: 100%;
  margin-bottom: -50px;
}
.footer,
.push {
  height: 75px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue